import img from '/static/img/banner/homeBanner/home.jpg';
// import img1 from '/static/img/banner/homeBanner/home1.jpg';
// import img2 from '/static/img/banner/homeBanner/home2.jpg';

// 函数来更新 bannerList
const bannerList = [
    {
      id: 1,
      img: img,
      desc: '',
    },
    // {
    //   id: 2,
    //   img: img1,
    //   desc: '',
    // },
    // {
    //   id: 3,
    //   img: img2,
    //   desc: '',
    // },
  ]
// 导出 bannerList
export default {
  bannerList
};
